import React from 'react';

const Profile = () => {
  return (
      <div style={styles.container}>
        <h1 style={styles.heading}>Construction Company Profile</h1>
        <p style={styles.subtext}>Coming Soon...</p>
      </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '4rem',
  },
  heading: {
    fontSize: '2rem',
    fontWeight: 'bold',
  },
  subtext: {
    fontSize: '1.2rem',
    color: '#777',
    marginTop: '1rem',
  },
};

export default Profile;
